import React, { useState } from 'react';
import moment from 'moment';
import PagedTable from '../PagedTable';

/**
 * @description Flow Org. pending invitation list
 *
 * Display a list of sent tenant invitations and their statuses.
 */
const PendingTenantInviteList = ({ invitations = [], organizationId }) => {
    const [page, setPage] = useState(1);
    const pageSize = 20;
    const pending = invitations.filter(item => item.type === 'tenant' && item.status !== 'accepted' && item.organization.id === organizationId);

    return (
        <>
            <h4>Tenants with pending or rejected invitations</h4>
            <PagedTable
                className="table margin-top"
                columns={[
                    {
                        renderHeader: () => 'Tenant',
                        renderCell: ({ item }) => (
                            <span title={`ID: ${item.tenant.id}`}>
                                {item.tenant.developerName} 
                            </span>
                        ),
                    },
                    {
                        renderHeader: () => 'Status',
                        renderCell: ({ item }) => <span className="capitalize">{item.status}</span>,
                        size: '20%',
                    },
                    {
                        renderHeader: () => 'Date Sent',
                        renderCell: ({ item }) => moment(item.invitedAt).format('lll'),
                        size: '175px',
                    },
                ]}
                items={pending}
                page={page}
                pageSize={pageSize}
                onPageClick={setPage}
            />
        </>
    );
};

export default PendingTenantInviteList;
